import { createSlice } from "@reduxjs/toolkit";

const initialActivitiesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentActivitySlice = createSlice({
  name: "studentActivities",
  initialState: initialActivitiesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getActivities
    activitiesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },    
    // getAllList
    allListFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entity.sections;
      state.teachers = entity.teachers;
      state.activityTypes = entity.activityTypes;
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entity.sections;
      state.teachers = entity.teachers;
    },
    // getExplanation
    explanationFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.explanation = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanExplanation
    explanationCleaned: (state) => {
      state.explanation = undefined;
    },
    // cleanActivitiesState
    activitiesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});